import React from 'react';

import LinkifyIt from 'linkify-it';

import { normalizeUrl } from '@atlaskit/adf-schema';

const linkify = LinkifyIt();
linkify.set({ fuzzyEmail: false });
linkify.add('sourcetree:', 'http:');

type Props = {
  message?: string;
};

/**
 * This component takes a string that is expected to have links within it, returns a component of several elements
 * that represent a linkifed version of that string.
 * Link-less substrings are represented as text nodes and links are encapsulated with <a> tags. If the message
 * is undefined or empty, just `null` is returned.
 * @param message A string
 */
const LinkedMessage = ({ message }: Props) => {
  if (!message) return null;

  const schemas = linkify.match(message);
  if (!schemas) return <>{message}</>;

  let prevIndex = 0;
  const result = schemas.reduce((elements, schema) => {
    const plaintext = message.substring(prevIndex, schema.index);
    if (plaintext) elements.push(plaintext);
    prevIndex = schema.lastIndex;

    const url = normalizeUrl(schema.url);
    elements.push(
      <a key={`${schema.lastIndex}_${url}`} href={`${url}`}>
        {schema.raw}
      </a>
    );

    return elements;
  }, [] as (JSX.Element | string)[]);

  const { lastIndex } = schemas[schemas.length - 1];
  if (lastIndex !== message.length) {
    result.push(message.substring(lastIndex, message.length));
  }

  return <>{result}</>;
};

export default React.memo(LinkedMessage);
